import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { lazyWithRetry } from 'src/utils/helpers'

export const Icons = {
  MinusCircle: lazyWithRetry(
    () =>
      import(
        /* webpackChunkName: "veneer-icon-1" */ '@veneer/core/dist/scripts/icons/icon_minus_circle'
      )
  ),
  DashboardApplication: lazyWithRetry(
    () =>
      import(
        /* webpackChunkName: "veneer-icon-2" */ '@veneer/core/dist/scripts/icons/icon_dashboard_application'
      )
  ),
  InkDropCheckmarkCircle: lazyWithRetry(
    () =>
      import(
        /* webpackChunkName: "veneer-icon-3" */ '@veneer/core/dist/scripts/icons/icon_ink_drop_checkmark_circle'
      )
  ),
  Cloud: lazyWithRetry(
    () =>
      import(
        /* webpackChunkName: "veneer-icon-4" */ '@veneer/core/dist/scripts/icons/icon_cloud'
      )
  ),
  Envelope: lazyWithRetry(
    () =>
      import(
        /* webpackChunkName: "veneer-icon-5" */ '@veneer/core/dist/scripts/icons/icon_envelope'
      )
  ),
  Bell: lazyWithRetry(
    () =>
      import(
        /* webpackChunkName: "veneer-icon-6" */ '@veneer/core/dist/scripts/icons/icon_bell'
      )
  ),
  ArrowCircleRight: lazyWithRetry(
    () =>
      import(
        /* webpackChunkName: "veneer-icon-7" */ '@veneer/core/dist/scripts/icons/icon_arrow_circle_right'
      )
  ),
  LogoHp: lazyWithRetry(async () => {
    const { LogoHp } = await import(
      /* webpackChunkName: "veneer-logo-1" */ '@veneer/core/dist/scripts/logos/logos/hp_logo/logo_hp'
    )
    return { default: LogoHp }
  }),
  LogoHpPlus: lazyWithRetry(
    () =>
      import(
        /* webpackChunkName: "veneer-logo-2" */ './custom-icons/HpPlusLogo'
      )
  ),
  DocumentScanCloud: lazyWithRetry(
    () =>
      import(
        /* webpackChunkName: "veneer-icon-8" */ '@veneer/core/dist/scripts/icons/icon_document_scan_cloud'
      )
  ),
  PhonePrint: lazyWithRetry(
    () =>
      import(
        /* webpackChunkName: "veneer-icon-9" */ '@veneer/core/dist/scripts/icons/icon_phone_print'
      )
  ),
  WarningAlt: lazyWithRetry(
    () =>
      import(
        /* webpackChunkName: "veneer-icon-10" */ '@veneer/core/dist/scripts/icons/icon_warning_alt'
      )
  )
}

export function VeneerIcon({ icon, ...props }) {
  const Icon = Icons[icon]

  return (
    <Suspense fallback={<></>}>
      <Icon {...props} />
    </Suspense>
  )
}

VeneerIcon.propTypes = {
  icon: PropTypes.string
}
